import { motion } from 'framer-motion'

const advantages = [
  'Rich product variety across prosthetic limbs, components, silicone prostheses and materials.',
  'Strict quality control for stable product performance and reliable shipment standards.',
  'Professional customer service for product matching, catalog support and export communication.',
  'Collaboration with multiple international logistics companies for safe and timely delivery.'
]

const About = () => {
  return (
    <section id="about" className="bg-white py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="mx-auto max-w-3xl"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-teal-700">
            Company Advantages
          </p>
          <h2 className="mt-4 text-4xl font-semibold leading-tight text-slate-950 md:text-5xl">
            Quality first, customer first, from catalog to delivery.
          </h2>
          <p className="mt-6 text-lg leading-8 text-slate-600">
            The company is demand-oriented and continuously optimizes product quality and service
            level, helping international buyers source rehabilitation products with confidence.
          </p>

          <div className="mt-8 grid gap-4">
            {advantages.map((advantage, index) => (
              <div key={advantage} className="flex gap-4 border-b border-slate-200 pb-4">
                <span className="text-sm font-semibold text-teal-700">0{index + 1}</span>
                <p className="text-sm leading-7 text-slate-600">{advantage}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  )
}

export default About
